import { render, staticRenderFns } from "./ProductInfoStickyHeader.vue?vue&type=template&id=5bb2a7e3&scoped=true&"
import script from "./ProductInfoStickyHeader.vue?vue&type=script&lang=js&"
export * from "./ProductInfoStickyHeader.vue?vue&type=script&lang=js&"
import style0 from "./ProductInfoStickyHeader.vue?vue&type=style&index=0&id=5bb2a7e3&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5bb2a7e3",
  null
  
)

export default component.exports